import {useHubQuery} from '../../QueryProvider'

export const useGetRequestForQuotesRegions = (userCountry: string) => {
  return useHubQuery('requestForQuotesRegions', [userCountry], {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  })
}
